module.exports = __webpack_public_path__ + "static/media/letterboxd.df81456f.svg";